import { defaultEventStatuses } from '../pages/events/SingleEvent/StatusChip'

export const getContrastText = (hex) => {
  if (!hex || typeof hex !== 'string' || !hex.startsWith('#')) {
    return '#ffffff'
  }

  const cleanHex = hex.replace('#', '')

  const fullHex =
    cleanHex.length === 3
      ? cleanHex
          .split('')
          .map((char) => char + char)
          .join('')
      : cleanHex

  const r = parseInt(fullHex.substring(0, 2), 16)
  const g = parseInt(fullHex.substring(2, 4), 16)
  const b = parseInt(fullHex.substring(4, 6), 16)

  const brightness = (r * 299 + g * 587 + b * 114) / 1000

  return brightness > 155 ? '#000000' : '#ffffff'
}

export const getStatusColourConfig = (status, statuses = {}) => {
  const main = statuses?.[status] || defaultEventStatuses?.[status] || '#3A475C'

  return {
    main,
    contrast: getContrastText(main),
  }
}
